export default __webpack_public_path__ + "static/media/down.c1badca0.svg";